import { render, staticRenderFns } from "./ActivitiesOverview.vue?vue&type=template&id=85f9b5b2&scoped=true&"
import script from "./ActivitiesOverview.vue?vue&type=script&lang=js&"
export * from "./ActivitiesOverview.vue?vue&type=script&lang=js&"
import style0 from "./ActivitiesOverview.vue?vue&type=style&index=0&id=85f9b5b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f9b5b2",
  null
  
)

export default component.exports